/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocialHistoryUpsertRequestDto
 */
export interface SocialHistoryUpsertRequestDto {
    /**
     * Unique identifier for the patient's social history record.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    id?: string;
    /**
     * Patient's current relationship status (e.g., Single, Married, Partnered, etc.).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    relationship: SocialHistoryUpsertRequestDtoRelationshipEnum;
    /**
     * Indicates if the patient has children.
     * @type {boolean}
     * @memberof SocialHistoryUpsertRequestDto
     */
    hasChildren?: boolean;
    /**
     * Number of children the patient has.
     * @type {number}
     * @memberof SocialHistoryUpsertRequestDto
     */
    numberOfChildren?: number;
    /**
     * Age of children the patient has.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    agesOfChildren?: string;
    /**
     * Patient's tobacco use status (Never, Former, Current).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    tobaccoUse: SocialHistoryUpsertRequestDtoTobaccoUseEnum;
    /**
     * Patient's tobacco use amount.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    tobaccoUseAmount: string;
    /**
     * Patient's alcohol use frequency (Never, Occasionally, Weekly, Daily).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    alcoholUse: SocialHistoryUpsertRequestDtoAlcoholUseEnum;
    /**
     * Patient's alcohol use amount.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    alcoholUseAmount: string;
    /**
     * Indicates if the patient uses cannabis or other drugs.
     * @type {boolean}
     * @memberof SocialHistoryUpsertRequestDto
     */
    cannabisOrDrugUse: boolean;
    /**
     * Patient's cannabis or drug use amount.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    cannabisOrDrugUseAmount: string;
    /**
     * Patient's caffeine consumption (None, 1-2 cups/day, 3+ cups per day).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    caffeineUse: SocialHistoryUpsertRequestDtoCaffeineUseEnum;
    /**
     * Patient's caffeine source.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    caffeineSource: string;
    /**
     * Average number of hours the patient sleeps per night.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    sleepHours: SocialHistoryUpsertRequestDtoSleepHoursEnum;
    /**
     * Patient's self-reported sleep quality (Poor, Fair, Good).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    sleepQuality: SocialHistoryUpsertRequestDtoSleepQualityEnum;
    /**
     * Indicates if the patient has trouble sleeping.
     * @type {boolean}
     * @memberof SocialHistoryUpsertRequestDto
     */
    sleepTrouble: boolean;
    /**
     * Indicates if the patient takes sleep aids or medication.
     * @type {boolean}
     * @memberof SocialHistoryUpsertRequestDto
     */
    sleepAidsOrMedication?: boolean;
    /**
     * Patient's routine one hour before bed.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    bedtimeRoutine?: string;
    /**
     * Type of physical activity the patient participates in (e.g., running, swimming).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    physicalActivityType?: string;
    /**
     * Number of times per week the patient engages in physical activity.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    physicalActivityFrequency: string;
    /**
     * Average duration (in minutes) of each physical activity session.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    physicalActivityMinutesPerSession?: string;
    /**
     * When the patient prefers to exercise.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    preferredExerciseTime?: string;
    /**
     * Physical recovery therapies the patient utilizes.
     * @type {Array<string>}
     * @memberof SocialHistoryUpsertRequestDto
     */
    physicalRecoveryTherapies?: Array<SocialHistoryUpsertRequestDtoPhysicalRecoveryTherapiesEnum>;
    /**
     * Other physical recovery therapies the patient uses.
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    otherTherapies?: string;
    /**
     * Patient's perceived stress level (Low, Moderate, High).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    stressLevel: SocialHistoryUpsertRequestDtoStressLevelEnum;
    /**
     * Patient's relationship stresses (None, Family, Romantic, Business, Friends).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    relationshipStresses: SocialHistoryUpsertRequestDtoRelationshipStressesEnum;
    /**
     * Primary sources of stress for the patient (e.g., work, family).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    stressSource?: string;
    /**
     * Methods the patient uses to cope with stress (e.g., exercise, meditation).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    stressCopingMethods?: string;
    /**
     * Indicates if the patient has a support system.
     * @type {boolean}
     * @memberof SocialHistoryUpsertRequestDto
     */
    hasSupportSystem: boolean;
    /**
     * Additional note about the patient's social history (e.g., allergies, chronic conditions).
     * @type {string}
     * @memberof SocialHistoryUpsertRequestDto
     */
    additionalInformation?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof SocialHistoryUpsertRequestDto
     */
    isOnboarding?: boolean;
}


/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoRelationshipEnum = {
    Single: 'Single',
    Married: 'Married',
    Partnered: 'Partnered',
    Divorced: 'Divorced',
    Widowed: 'Widowed'
} as const;
export type SocialHistoryUpsertRequestDtoRelationshipEnum = typeof SocialHistoryUpsertRequestDtoRelationshipEnum[keyof typeof SocialHistoryUpsertRequestDtoRelationshipEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoTobaccoUseEnum = {
    Never: 'Never',
    Former: 'Former',
    Current: 'Current'
} as const;
export type SocialHistoryUpsertRequestDtoTobaccoUseEnum = typeof SocialHistoryUpsertRequestDtoTobaccoUseEnum[keyof typeof SocialHistoryUpsertRequestDtoTobaccoUseEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoAlcoholUseEnum = {
    Never: 'Never',
    Occasionally: 'Occasionally',
    Weekly: 'Weekly',
    Daily: 'Daily'
} as const;
export type SocialHistoryUpsertRequestDtoAlcoholUseEnum = typeof SocialHistoryUpsertRequestDtoAlcoholUseEnum[keyof typeof SocialHistoryUpsertRequestDtoAlcoholUseEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoCaffeineUseEnum = {
    None: 'None',
    _12CupsDay: '1-2 cups/day',
    _3CupsPerDay: '3+ cups per day'
} as const;
export type SocialHistoryUpsertRequestDtoCaffeineUseEnum = typeof SocialHistoryUpsertRequestDtoCaffeineUseEnum[keyof typeof SocialHistoryUpsertRequestDtoCaffeineUseEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoSleepHoursEnum = {
    _12HoursNight: '1-2 hours/night',
    _34HoursNight: '3-4 hours/night',
    _56HoursNight: '5-6 hours/night',
    _78HoursNight: '7-8 hours/night',
    _910HoursNight: '9-10 hours/night',
    _1112HoursNight: '11-12 hours/night'
} as const;
export type SocialHistoryUpsertRequestDtoSleepHoursEnum = typeof SocialHistoryUpsertRequestDtoSleepHoursEnum[keyof typeof SocialHistoryUpsertRequestDtoSleepHoursEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoSleepQualityEnum = {
    Poor: 'Poor',
    Fair: 'Fair',
    Good: 'Good'
} as const;
export type SocialHistoryUpsertRequestDtoSleepQualityEnum = typeof SocialHistoryUpsertRequestDtoSleepQualityEnum[keyof typeof SocialHistoryUpsertRequestDtoSleepQualityEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoPhysicalRecoveryTherapiesEnum = {
    Acupuncture: 'Acupuncture',
    ColdPlunge: 'Cold plunge',
    HbotHyperbaricOxygenTherapy: 'HBOT (Hyperbaric Oxygen Therapy)',
    InfraredSauna: 'Infrared sauna',
    RedLightTherapy: 'Red light therapy',
    SteamRooms: 'Steam Rooms'
} as const;
export type SocialHistoryUpsertRequestDtoPhysicalRecoveryTherapiesEnum = typeof SocialHistoryUpsertRequestDtoPhysicalRecoveryTherapiesEnum[keyof typeof SocialHistoryUpsertRequestDtoPhysicalRecoveryTherapiesEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoStressLevelEnum = {
    Low: 'Low',
    Moderate: 'Moderate',
    High: 'High'
} as const;
export type SocialHistoryUpsertRequestDtoStressLevelEnum = typeof SocialHistoryUpsertRequestDtoStressLevelEnum[keyof typeof SocialHistoryUpsertRequestDtoStressLevelEnum];

/**
 * @export
 */
export const SocialHistoryUpsertRequestDtoRelationshipStressesEnum = {
    None: 'None',
    Family: 'Family',
    Romantic: 'Romantic',
    Business: 'Business',
    Friends: 'Friends'
} as const;
export type SocialHistoryUpsertRequestDtoRelationshipStressesEnum = typeof SocialHistoryUpsertRequestDtoRelationshipStressesEnum[keyof typeof SocialHistoryUpsertRequestDtoRelationshipStressesEnum];


/**
 * Check if a given object implements the SocialHistoryUpsertRequestDto interface.
 */
export function instanceOfSocialHistoryUpsertRequestDto(value: object): value is SocialHistoryUpsertRequestDto {
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('tobaccoUse' in value) || value['tobaccoUse'] === undefined) return false;
    if (!('tobaccoUseAmount' in value) || value['tobaccoUseAmount'] === undefined) return false;
    if (!('alcoholUse' in value) || value['alcoholUse'] === undefined) return false;
    if (!('alcoholUseAmount' in value) || value['alcoholUseAmount'] === undefined) return false;
    if (!('cannabisOrDrugUse' in value) || value['cannabisOrDrugUse'] === undefined) return false;
    if (!('cannabisOrDrugUseAmount' in value) || value['cannabisOrDrugUseAmount'] === undefined) return false;
    if (!('caffeineUse' in value) || value['caffeineUse'] === undefined) return false;
    if (!('caffeineSource' in value) || value['caffeineSource'] === undefined) return false;
    if (!('sleepHours' in value) || value['sleepHours'] === undefined) return false;
    if (!('sleepQuality' in value) || value['sleepQuality'] === undefined) return false;
    if (!('sleepTrouble' in value) || value['sleepTrouble'] === undefined) return false;
    if (!('physicalActivityFrequency' in value) || value['physicalActivityFrequency'] === undefined) return false;
    if (!('stressLevel' in value) || value['stressLevel'] === undefined) return false;
    if (!('relationshipStresses' in value) || value['relationshipStresses'] === undefined) return false;
    if (!('hasSupportSystem' in value) || value['hasSupportSystem'] === undefined) return false;
    return true;
}

export function SocialHistoryUpsertRequestDtoFromJSON(json: any): SocialHistoryUpsertRequestDto {
    return SocialHistoryUpsertRequestDtoFromJSONTyped(json, false);
}

export function SocialHistoryUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialHistoryUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'relationship': json['relationship'],
        'hasChildren': json['hasChildren'] == null ? undefined : json['hasChildren'],
        'numberOfChildren': json['numberOfChildren'] == null ? undefined : json['numberOfChildren'],
        'agesOfChildren': json['agesOfChildren'] == null ? undefined : json['agesOfChildren'],
        'tobaccoUse': json['tobaccoUse'],
        'tobaccoUseAmount': json['tobaccoUseAmount'],
        'alcoholUse': json['alcoholUse'],
        'alcoholUseAmount': json['alcoholUseAmount'],
        'cannabisOrDrugUse': json['cannabisOrDrugUse'],
        'cannabisOrDrugUseAmount': json['cannabisOrDrugUseAmount'],
        'caffeineUse': json['caffeineUse'],
        'caffeineSource': json['caffeineSource'],
        'sleepHours': json['sleepHours'],
        'sleepQuality': json['sleepQuality'],
        'sleepTrouble': json['sleepTrouble'],
        'sleepAidsOrMedication': json['sleepAidsOrMedication'] == null ? undefined : json['sleepAidsOrMedication'],
        'bedtimeRoutine': json['bedtimeRoutine'] == null ? undefined : json['bedtimeRoutine'],
        'physicalActivityType': json['physicalActivityType'] == null ? undefined : json['physicalActivityType'],
        'physicalActivityFrequency': json['physicalActivityFrequency'],
        'physicalActivityMinutesPerSession': json['physicalActivityMinutesPerSession'] == null ? undefined : json['physicalActivityMinutesPerSession'],
        'preferredExerciseTime': json['preferredExerciseTime'] == null ? undefined : json['preferredExerciseTime'],
        'physicalRecoveryTherapies': json['physicalRecoveryTherapies'] == null ? undefined : json['physicalRecoveryTherapies'],
        'otherTherapies': json['otherTherapies'] == null ? undefined : json['otherTherapies'],
        'stressLevel': json['stressLevel'],
        'relationshipStresses': json['relationshipStresses'],
        'stressSource': json['stressSource'] == null ? undefined : json['stressSource'],
        'stressCopingMethods': json['stressCopingMethods'] == null ? undefined : json['stressCopingMethods'],
        'hasSupportSystem': json['hasSupportSystem'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function SocialHistoryUpsertRequestDtoToJSON(json: any): SocialHistoryUpsertRequestDto {
    return SocialHistoryUpsertRequestDtoToJSONTyped(json, false);
}

export function SocialHistoryUpsertRequestDtoToJSONTyped(value?: SocialHistoryUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'relationship': value['relationship'],
        'hasChildren': value['hasChildren'],
        'numberOfChildren': value['numberOfChildren'],
        'agesOfChildren': value['agesOfChildren'],
        'tobaccoUse': value['tobaccoUse'],
        'tobaccoUseAmount': value['tobaccoUseAmount'],
        'alcoholUse': value['alcoholUse'],
        'alcoholUseAmount': value['alcoholUseAmount'],
        'cannabisOrDrugUse': value['cannabisOrDrugUse'],
        'cannabisOrDrugUseAmount': value['cannabisOrDrugUseAmount'],
        'caffeineUse': value['caffeineUse'],
        'caffeineSource': value['caffeineSource'],
        'sleepHours': value['sleepHours'],
        'sleepQuality': value['sleepQuality'],
        'sleepTrouble': value['sleepTrouble'],
        'sleepAidsOrMedication': value['sleepAidsOrMedication'],
        'bedtimeRoutine': value['bedtimeRoutine'],
        'physicalActivityType': value['physicalActivityType'],
        'physicalActivityFrequency': value['physicalActivityFrequency'],
        'physicalActivityMinutesPerSession': value['physicalActivityMinutesPerSession'],
        'preferredExerciseTime': value['preferredExerciseTime'],
        'physicalRecoveryTherapies': value['physicalRecoveryTherapies'],
        'otherTherapies': value['otherTherapies'],
        'stressLevel': value['stressLevel'],
        'relationshipStresses': value['relationshipStresses'],
        'stressSource': value['stressSource'],
        'stressCopingMethods': value['stressCopingMethods'],
        'hasSupportSystem': value['hasSupportSystem'],
        'additionalInformation': value['additionalInformation'],
        'isOnboarding': value['isOnboarding'],
    };
}

